<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">

                <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                                style="background: url('/assets/images/PexelsForkInRoadAroundBuilding1.jpg')  center;">
                        <h2 class="widget-user-username text-left">Drop Bad Habits. <br/>Create Great Habits.</h2>
                        <h3 class="widget-user-username text-right">My Habits make my Future.</h3>
                        <!-- <h5 class="widget-user-desc text-right">Habits change your Future.</h5> -->
                    </div>
                    <div class="widget-user-image">
                        <img class="img-circle" src="/assets/images/beginner_child.png" alt="User Avatar">
                    </div>
                </div>
<!-- <div class="tab-pane fade" id="custom-tabs-five-overlay-dark" role="tabpanel" aria-labelledby="custom-tabs-five-overlay-dark-tab">
        <div class="overlay-wrapper">
            <div class="overlay dark"><i class="fas fa-3x fa-sync-alt fa-spin"></i>
                <div class="text-bold pt-2">Loading...</div> -->
                    <div class=" card card-primary col-sm-12 col-xl-6 mx-auto">
                    <div class="card-header">
                        <h4 class="card-title text-center">How to Setup your Habits</h4>
                        <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-minus"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-card-widget="remove">
                            <i class="fas fa-times"></i>
                        </button>
                        </div>
                    </div>
                    <div class="card-body" >
                        <div style="text-align:left;" v-html="headerHTML">
                        </div>
                    </div>
                    <!-- /.card-body -->
                    </div>
                    <div class="list-group-item">
                        <div class="row d-flex ">
                            <div class="attachment-block clearfix col-12">
                                <!-- <img class="attachment-img"  src="assets/images/pexels-iconcom-growing_young_habit.jpg" alt="Grow Your Habit"/> -->
                                <h4 style="word-wrap:break-word;align:center;" class="mx-auto bg-dark" >Define (and Add) a Habit You need to Build or Fix:</h4>
                            </div>
                            <div  class="col-lg-4 col-md-4">
                                <div class="content-box-gray card" >
                                    <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >Habit Header</h5>
                                    </div>
                                    <div class="content">
                                        <div class="input-group" style="font-size:.85em;">
                                            <h6 :hidden="!hideHeaderInputs"  style="font-size:.85em;"><em>Habit Name:</em> {{habit_name}}</h6>
                                            <input id="id_habitname" :hidden="hideHeaderInputs" type="text" class="form-control" v-model="habit_name" placeholder="Habit Name: e.g., Healthy Living" required>
                                            <div  :hidden="hideHeaderInputs" class="input-group-append">
                                                <div class="input-group-text">
                                                    <span class="fas fa-file-signature"></span>
                                                    <p class="small text-danger mb-3" v-html="errors.name"></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group" style="font-size:.85em;">
                                            <h6 :hidden="!hideHeaderInputs"  style="font-size:.85em;"><em>Habit Purpose:</em> {{habit_desc}}</h6>
                                            <input id="id_habitdesc" :hidden="hideHeaderInputs" type="text" class="form-control" v-model="habit_desc" placeholder="What this Habit will do for you" required>
                                            <div  :hidden="hideHeaderInputs" class="input-group-append">
                                                <div class="input-group-text">
                                                <span class="fas fa-info"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group" style="font-size:.85em;">
                                            <h6 :hidden="!hideHeaderInputs"  style="font-size:.85em;"><em>Habit Frequency:</em> {{habit_freq}}</h6>
                                            <!-- <input type="email" class="form-control" v-model="email" placeholder="Check Frequency" required> -->
                                            <select id="id_habitfreq" name="habit_freq" class="form-control" v-model="habit_freq" :hidden="hideHeaderInputs" required >
                                                <option disabled selected value="">Check Frequency</option>
                                                <option value="Daily">Daily</option>
                                                <option value="Weekdays">Weekdays</option>
                                                <option value="Weekly">Weekly</option>
                                            </select>
                                            <div :hidden="hideHeaderInputs" class="input-group-append">
                                                <div class="input-group-text">
                                                <span class="fas fa-wave-sine"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <p class="small text-danger mb-1" v-html="errors.header"></p>
                                        <div class=" btn-container">
                                            <a class="btn btn-warning btn-sm" :disabled="readySaveHeaderInfo()" :hidden="hideHeaderInputs" id="confHeadBtn" @click="confirmHeaders()"
                                                title="confirm">Step 1: Confirm Habit Headers <span class="fas fa-save"></span>
                                            </a>
                                        </div>
                                        <table style="font-size: .75em;" class="table table-sm table-hover table-light table-striped"  v-if="habitcomponents.length>0">
                                            <thead class="thead-default"><tr><td>Habit Component<br/>(Description)</td><td>Component Weight<br/>(Importance)</td><td>Action</td></tr></thead>
                                            <tbody>
                                                <tr v-for="hc in habitcomponents"  :key="hc.id">
                                                    <td>{{hc.name}}<br/>(<i>{{hc.description}}</i>)</td><td>{{hc.weight}}</td>
                                                    <td><button class="btn btn-light btn-sm" title="Delete" v-on:click="deleteComponent(hc.id)"><i class="fas fa-trash text-red"></i></button></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div  class="col-lg-4 col-md-4">
                                <div class="content-box-gray card" >
                                    <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >Habit Component Setup:</h5>
                                    </div>
                                    <div class="content">
                                    <!-- <p class="small text-warning" v-html="errors.maxed_components" :hidden="!maxedOutCustomHabits()"></p> -->
                                        <div class="input-group"  :hidden="maxxedOutCustomHabits()">
                                            <input type="text" v-model="hc_name" id="hc_name_input"  class="form-control"  placeholder="Component Name: e.g., Exercise" required>
                                            <div class="input-group-append">
                                                <div class="input-group-text" >
                                                    <span class="fas fa-pen"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group"  style="font-size: .5em;" :hidden="maxxedOutCustomHabits()">
                                        <input type="text" v-model="hc_desc" id="hc_desc_input"  class="form-control"  placeholder="Description: e.g. At least for 45 mins." required>
                                            <div class="input-group-append">
                                                <div class="input-group-text" >
                                                <span class="fas fa-pen"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group"  :hidden="maxxedOutCustomHabits()">
                                            <select id="id_habitfreq" name="component_weight" class="form-control" v-model="hc_weight"  required >
                                                <option disabled selected value="">Component weight(importance)</option>
                                                    <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="5">5</option>
                                            </select>
                                            <div class="input-group-append"  :hidden="maxxedOutCustomHabits()">
                                                <div class="input-group-text">
                                                <span class="fas fa-weight"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <p class="small text-danger mb-1" v-html="errors.hc_add"></p>
                                        <div class="btn-container">
                                            <button class="btn btn-primary btn-sm"  :hidden="maxxedOutCustomHabits()" :disabled="maxxedOutCustomHabits()" @click="addCustomHabitCheck()">Step 2<sup>n</sup> : Add Habit Component <i class="fas fa-plus"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-container"><p class="small text-danger mb-1" v-html="errors.hc_confirm"></p>
                                    <button class="btn btn-primary btn-sm" :disabled="checkCreatedHabit()" @click="updateHabitsWatchlist()">Step 3 : Finalize this Habit Definition <i class="fas fa-thumbs-up"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row " v-if="allhabits.length>0">
                        <div  class="col-auto col-lg-6 col-md-6" style="margin:auto;">
                            <div class="content-box-gray card" >
                                    <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >My Habits Watch-List:</h5>
                                    </div>
                                    <div class="content">
                                        <table style="font-size: .75em;" class="table table-sm table-hover table-light table-striped">
                                            <!-- <tr><td colspan="3"><h6>Habits List for tracking:</h6></td></tr> -->
                                            <thead class="thead-light">  <tr ><th>Habit-Name(Desc)</th><th>Check<br/>Freq.</th><th>Actions</th></tr></thead>
                                            <tr v-for="habit in allhabits" :key="habit.id">
                                                <td><em>{{habit.name}}</em><br/><small>{{habit.description}}</small></td><td>{{habit.frequency}}</td><td>

                                                    <!-- <i v-on:click="trackHabit(habit.id)" class="fas  fa-shoe-prints" title="Track Habit"></i> &nbsp;
                                                    <i v-on:click="viewHabitResults(habit.id)" class="fas fa-eye fai-blue" title="View Habit Performance"></i> &nbsp; -->
                                                    <i v-on:click="swalConfirm(habit.id)" class="fas fa-trash fai-red" title="Delete Habit"></i>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        <!--    </div>
            </div>
        </div> -->

            </div>
        </div>
    </div>
</template>
<script>

import axios from 'axios';
import EventBus from '../../event-bus';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import { v4 as uuidv4 } from 'uuid';
import HABITSETUPHEADERINFO from '../global/shared/info'


export default {
    components: { Errors },
    name: "HabitSetup",
    data() {
        return {
            name: '',
            email: '',
            username: '',
            success: false,
            failure: false,
            message: '',
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                hc_add: '',
                hc_confirm: '',
                maxed_components:''
            },
             userdata: '',
            nahme:'',
            weight:'',
            currentComponent: {
                name:'',
                weight:0
            },
            habitdata:[],
            habitcomponents:[],
            habit_freq: '',
            habitFreq:'',
            habit_name: '',
            habitName:'',
            habit_desc:'',
            habitDesc:'',
            hideHeaderInputs:false,
            habitcomponentstally:0,
            MAX_HABIT_COMPONENTS: 4,
            // customelementstracker:[],
            selectedDeleteElement:'',
            buttonAwakeN:false,
            buttonAwakeF:false,
            hc_name:'',
            hc_weight:'',
            hc_desc:'',
            saved_habit_id: '',
            allhabits:[],
            habitDOY:[],
            componentsDOY: [],
            headerHTML: '',

        }
    },
    props: {
        user:'',
        habits:[],
        habitdoy:[],
        componentsdoy:[],
    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.allhabits = JSON.parse(this.habits);
        this.habitDOY = JSON.parse(this.habitdoy);
        this.componentsDOY = JSON.parse(this.componentsdoy);
        //this.setUserData();
        // document.getElementById('confHeadBtn').disabled = true;
        this.componentName = new Array(this.MAX_HABIT_COMPONENTS);
        this.componentPoints = new Array(this.MAX_HABIT_COMPONENTS);
        this.deleteComponent = new Array(this.MAX_HABIT_COMPONENTS);
        this.headerHTML = HABITSETUPHEADERINFO;
    },

    methods: {
        updateHabitsWatchlist(){
           console.error('upd called');
           if (this.habitFreq != '' || this.habitName != '' ||  this.habitDesc != '' || this.habitcomponents.length <1) {
                this.updateToast("Congrats. Your Habit is fully created", 2000, 'success');
                window.location.reload();
           } else {
                // console.error('upd called throwing error');
                this.errors.hc_confirm = 'Please create a Habit Header and at least one Habit Component';
            }
        },
        checkCreatedHabit() {
            return !(this.habitFreq != '' && this.habitName != '' &&  this.habitDesc != '' && this.habitcomponents.length > 0);
        },
        readySaveHeaderInfo() {
            return !(this.habit_name.length < 4 || this.habit_desc.length < 4 || this.habit_freq != '');
        },
        viewHabitResults(habitID) {
            //  console.error('viewHabitChart.....');
            window.location.replace('/habits/'+ habitID + '/results/');
        },
        getHabitChartData(habitID) {
            var selHabitDOY = '';
            if(this.habitDOY.hasOwnProperty(habitID)) {
                //  console.error("Found habit");
                for (const [key, value] of Object.entries(this.habitDOY)) {
                    // console.log(`${key}: ${value}`);
                    if(key == habitID) selHabitDOY = value;
                }
            }
            // console.error(selHabitDOY);
            return selHabitDOY;
        },
        getHabitComponentsChartData(habitID) {
            var selHabitCompDOY = '';
             if(this.habitDOY.hasOwnProperty(habitID)) {
                //  console.error("Found habit components");
                for (const [key, value] of Object.entries(this.componentsDOY)) {
                    // console.log(`${key}: ${value}`);
                    if(key == habitID) selHabitCompDOY = value;
                }
            }
            // console.error(selHabitCompDOY);
            return selHabitCompDOY;
        },
        /**
        * @param {null}
        * @return {String} guid
        */
        getGUID() {
            var guid = uuidv4();
            // console.log("GUID: " + guid);
            return guid;
        },
        getInputVal(el_id) {
            let inp = document.getElementById(el_id);
            // console.error(inp.value);
            return inp.value;
        },

        disableConfHabitHeadButton() {
        // return this.habit_name.length<4 && this.habit_freq =='';
            return this.getInputVal('hc_name_input').length<4 && this.habit_freq=='';
        },
        confirmHeaders(){
            if(!this.disableConfHabitHeadButton()) {
                console.log("Confirming Headers....");
                this.habitFreq = this.habit_freq;
                this.habitName = this.habit_name;
                this.habitDesc = this.habit_desc;
                this.hideHeaderInputs =true;
                this.saveHeaders(this.habitName, this.habitFreq, this.habitDesc)
                this.errors.header = "";
            } else {
                // console.error("Nothing done...");
                this.errors.header = "Please fill out the above fields first."
            }
        },
        trackHabit(habit_id) {
            console.error('track habit called.....');
            // window.location.href = "/habits/track/"+ habit_id;
            var selHabitData = this.getHabitData(habit_id);
            var data = {habitdata: selHabitData, userdata:this.userdata }
            EventBus.$emit('displayHabitTrackerModal', data);
        },
        getHabitData(habit_id) {
            var retVal = '';
            [...this.allhabits].forEach((aHabit)=>{
                if(aHabit.id == habit_id) retVal =aHabit;
            });
            return retVal;
        },
        saveHeaders(habit_name, habit_frequency, habit_description) {
            axios.post('/habits/headers/saveupdate', {
                user_id:this.userdata.id,
                // habit_id: habit_id,
                name: habit_name,
                freq: habit_frequency,
                description: habit_description
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.saved_habit_id = res.data.habit_id;
                console.error(res.data.message + this.saved_habit_id);
                this.failure = false;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
            .finally(()=> {
                // location.reload();
            });

        },
        deleteComponent(component_id) {
            axios.post('/habits/components/delete', {
                component_id: component_id,
                user_id: this.userdata.id
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                console.error(res.data.message );
                this.habitdata = JSON.parse(res.data.current_habit);
                this.habitcomponents = this.habitdata.components;
                this.failure = false;
                this.hc_name = '';
                this.hc_desc = '';
                this.hc_weight = '';
                this.errors.hc_add ="";
                this.habitcomponentstally--;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            });
        },
        saveComponent(component_id, name, weight, desc) {
            axios.post('/habits/components/saveupdate', {
                id: component_id,
                habit_id: this.saved_habit_id,
                name: name,
                weight: weight,
                description: desc
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                // console.error(res.data.message );
                this.habitdata = JSON.parse(res.data.current_habit);
                this.habitcomponents = this.habitdata.components;
                this.failure = false;

                this.hc_name = '';
                this.hc_desc = '';
                this.hc_weight = '';
                this.errors.hc_add ="";
                this.habitcomponentstally++;

            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            });
        },

        deleteHabit(habit_id) {
            let incomingdata = '';
            // console.error("Deleting habit: " + habit_id);
            axios.post('/habits/delete', {
                user_id:this.userdata.id,
                habit_id: habit_id
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.errors.success = true;
                this.removeHabitFromHabitData(habit_id);
                this.failure = false;
                this.updateToast(this.message, 2000, icon='success');
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
            .finally(() => {
                    this.$forceUpdate();
                });
        },
        removeHabitFromHabitData(habit_id) {
             this.allhabits = this.allhabits.filter(function (habit){
            return habit.id !== habit_id});
        },
        maxxedOutCustomHabits() {
            // console.log(this.habitcomponentstally >= this.MAX_HABIT_COMPONENTS);
            this.errors.maxed_components = 'We recommend not trying to track too many habit components.';
            return this.habitcomponentstally >= this.MAX_HABIT_COMPONENTS;
        },
        addCustomHabitCheck() {
            if(this.hc_name.length >0 && this.hc_weight > 0) {
                this.saveComponent('', this.hc_name, this.hc_weight, this.hc_desc);
                this.errors.hc_add =  (this.habitcomponentstally>=4)? "We recommend not trying to track too many habit components.<br/> (4 components on each habit is a good number).":'';
            } else {
                // console.error("Nothing added to Habit Components...")
                var err = '';
                if(this.hc_name.length<5) err= 'Component Name should be longer than 4 letters';
                if(this.hc_weight == 0 || this.hc_weight == '') err += '<br/> Please select a Component weight (importance)';
                this.errors.hc_add = err;
            }
        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
        swalConfirm(id) {
             Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to undo this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    // setTimeout( function (id) {
                    //     this.doDeleteSlice(id);
                    // }, 3000);
                    this.deleteHabit(id);
                    Swal.fire(
                        'Deletion in progress!',
                        '',
                        'success'
                    );
                }
            });
        },
    }
}
</script>

<style scoped>
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:#0707c0;
}
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#876759;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
.input-group input, select{
    margin-top:.2em;
}
.input-group .input-group-text{
    margin-top:.2em;
}
.shad{
padding:.2em;
padding-top:1em;
margin:.2em;
margin-bottom: 1em;
background: #f1f2f4;
border: 2.5px solid #fff;
border-radius: 4px;
box-shadow: 4px 4px 4px #222;
}
.how-to{
width:80%;
    @media (max-width: 768px) {
        width:90%;
    }
}


</style>
